import { render, staticRenderFns } from "./ayuda.vue?vue&type=template&id=17f05dde&scoped=true"
import script from "./ayuda.vue?vue&type=script&lang=js"
export * from "./ayuda.vue?vue&type=script&lang=js"
import style0 from "./ayuda.vue?vue&type=style&index=0&id=17f05dde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f05dde",
  null
  
)

export default component.exports